module.exports = __webpack_public_path__ + "static/story2-thumbnails-rect-250x125-1dd13508c086ff73d46bf360da43db57.jpg";